import { Reducer, AnyAction, Dispatch } from 'redux';
import { MeState } from './type';
import { fetchMe } from '../../api/me';

export const SET_ME = 'me/set';

const defaultState: MeState = {
    loaded: false,
    username: '',
    displayName: '',
    email: '',
    isAdmin: false,
    siteRole: 'master',
    accessStatus: 'none',
};

const reducer: Reducer<MeState> = (state: MeState = defaultState, action: AnyAction) => {
    switch (action.type) {
        case SET_ME:
            return { ...state, ...action.payload, loaded: true };
        default:
            return state;
    }
};

const actions = {
    set(payload: Partial<MeState>) {
        return { type: SET_ME, payload };
    },
    load() {
        return async (dispatch: Dispatch) => {
            try {
                const me = await fetchMe();
                dispatch(actions.set({
                    username: me.username,
                    displayName: me.displayName,
                    email: me.email,
                    isAdmin: me.isAdmin,
                    siteRole: me.siteRole || 'master',
                    // 老后端没有该字段时按 approved 兜底, 避免升级窗口内全员被闸门挡住
                    accessStatus: me.accessStatus || 'approved',
                }));
            } catch {
                // 拉失败按非 admin 处理, 后端依然拦截写操作.
                // accessStatus 按 approved 兜底: 网络抖动不该把人错误地关进申请页,
                // 真没权限时业务请求会被后端 AccessGuard (20103) 拦下.
                dispatch(actions.set({ isAdmin: false, accessStatus: 'approved' }));
            }
        };
    },
};

export default { reducer, actions };
